<div class="p-grid p-justify-center p-align-start wrapper-content flex-column mt-4 mb-5">
  <div class="col-12 px-0">
    <div class="app-card">
      <h1 class="card-header title-blue font-roboto-condensed  font-23 font-normal">{{trans.misPagos}}</h1>
      <div class="card-body">
        <custom-table [config]="customTable" />
      </div>
    </div>
  </div>
</div>

<app-detalle-transaccion-pse/>
